const MentionHook = {
  mounted() {
    this.textarea = this.el.querySelector("textarea");

    this.handleEvent("mention_selected", ({ username }) => {
      this.insertMention(username);
    });

    this._inputListener = () => {
      const query = this.getActiveMentionQuery();
      if (query !== null) {
        this.pushEventTo(this.el, "mention_search", { query });
      } else {
        this.pushEventTo(this.el, "mention_cancel", {});
      }
    };
    this.textarea.addEventListener("input", this._inputListener);

    // Prevent the textarea from losing focus when tapping the popover.
    // pointerdown fires before blur, so preventDefault() keeps focus (and the
    // mobile keyboard) on the textarea while still allowing phx-click to fire.
    this._pointerdownListener = (e) => {
      const popover = this.el.querySelector("[data-mention-popover]");
      if (popover && popover.contains(e.target)) {
        e.preventDefault();
      }
    };
    this.el.addEventListener("pointerdown", this._pointerdownListener);
  },

  destroyed() {
    if (this.textarea) {
      this.textarea.removeEventListener("input", this._inputListener);
    }
    this.el.removeEventListener("pointerdown", this._pointerdownListener);
  },

  getActiveMentionQuery() {
    const text = this.textarea.value;
    const cursor = this.textarea.selectionStart;
    const textUpToCursor = text.slice(0, cursor);
    const match = textUpToCursor.match(/@(\w*)$/);
    return match ? match[1] : null;
  },

  insertMention(username) {
    const text = this.textarea.value;
    const cursor = this.textarea.selectionStart;
    const textUpToCursor = text.slice(0, cursor);
    const match = textUpToCursor.match(/@\w*$/);
    if (!match) return;

    const start = cursor - match[0].length;
    const newText = text.slice(0, start) + "@" + username + " " + text.slice(cursor);
    this.textarea.value = newText;

    const newCursor = start + username.length + 2;
    this.textarea.setSelectionRange(newCursor, newCursor);
    this.textarea.focus();

    // Sync the new value back to the LiveView changeset
    this.textarea.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

export default MentionHook;
